import { createFileRoute, redirect } from '@tanstack/react-router'

import { flightResultsSearchSchema } from '@/lib/schemas/flight-results-search.schema'

export const Route = createFileRoute('/_booking/flights/results')({
  beforeLoad: ({ search }) => {
    throw redirect({ replace: true, search, to: '/vols/resultats' })
  },
  validateSearch: flightResultsSearchSchema,
})
